<template>
	<td>
		<div @dblclick="onDayOff" class="item" :class="{ 'dayOff': body.dayOff }">
			<droppable-item v-for="position in 4" :attrs="{ ...treeStructure, position }" :key="position">
				<planer-item
						v-if="position === body.position"
						:body="body"
						@updateStructure="onStructure"
						@updateStructureWidth="onStructureWidth"
						@updateStartDrop="onStartDrop"
						@updateLines="onLines"
						@updateEditWorkOrder="onEditWorkOrder"
				></planer-item>
			</droppable-item>
		</div>
	</td>
</template>

<script>
import PlanerItem from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerItem/PlanerItem";
import DroppableItem from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerTd/DroppableItem";

export default {
	name: "PlanerTd",
	components: {
		PlanerItem,
		DroppableItem
	},
	props: {
		body: Object,
		treeStructure: Object
	},
	methods: {
		onStructure(obj) {
			obj.from = this.treeStructure;
			this.$emit('updateStructure', obj);
		},
		onLines() {
			this.$emit('updateLines');
		},
		onEditWorkOrder(values) {
			this.$emit('updateEditWorkOrder', values);
		},
		onStructureWidth(values) {
			values.from = this.treeStructure;
			this.$emit('updateStructureWidth', values);
		},
		onStartDrop() {
			this.$emit('updateStartDrop');
		},
		onDayOff(event) {
			const target = event && event.target;
			if (!target.classList.contains('taskItem'))
				if (this.body.dayOff && !target.classList.contains('taskItem')) {
					this.$emit('updateDayOff', this.body.dayOff);
				}
		}
	}
};
</script>

<style scoped lang="scss">
.item {
	min-width: 60px;
	height: 60px;
	margin-right: -1px;
	pointer-events: none;

	.droppable {
		pointer-events: all;
	}
}

.dayOff {
	position: relative;
	background: #4e7aed59;
}

.droppable {
	position: relative;
	padding: 10px 0;
	width: 15px;
	height: 60px;
	float: left;
}
</style>
